import { AppInsightsErrorBoundary } from '@microsoft/applicationinsights-react-js'
import type { ReactElement } from 'react'

import Logo from '../components/ui/logo'
import { reactPlugin } from './useAppInsights'
import { AuthProvider, useAuth } from './useAuth'
import { BrandProvider, useBrand } from './useBrand'
import { CampaignProvider, useCampaign } from './useCampaign'
import { DealerProvider, useDealer, useDealerContext } from './useDealer'
import { FilterProvider, useFilter } from './useFilter'
import { ModelProvider, useModel } from './useModel'
import { QueryProvider, useQuery, useQueryContext } from './useQuery'

type Props = {
  children: ReactElement
}

const ContextProvider = ({ children }: Props) => {
  const Error = () => (
    <div className="flex flex-col min-h-screen items-center justify-center">
      <Logo className="object-center w-48 mb-10" />
      <h1 className="text-xl md:text-2xl lg:text-3xl">Error</h1>
    </div>
  )

  return (
    <AppInsightsErrorBoundary onError={Error} appInsights={reactPlugin}>
      <BrandProvider>
        <AuthProvider>
          <FilterProvider>
            <ModelProvider>
              <DealerProvider>
                <CampaignProvider>
                  <QueryProvider>{children}</QueryProvider>
                </CampaignProvider>
              </DealerProvider>
            </ModelProvider>
          </FilterProvider>
        </AuthProvider>
      </BrandProvider>
    </AppInsightsErrorBoundary>
  )
}

export {
  ContextProvider,
  useAuth,
  useBrand,
  useCampaign,
  useDealer,
  useDealerContext,
  useFilter,
  useModel,
  useQuery,
  useQueryContext,
}
